import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-status-badge',
  imports: [CommonModule],
  templateUrl: './status-badge.html',
  styleUrl: './status-badge.scss'
})
export class StatusBadge {

  status = input.required<string>();
  displayText = input.required<string>();
  size = input<'sm' | 'md' | 'lg'>('md');
  customClass = input<string>('');

  statusKey = () => this.status().toLowerCase().trim();
  iconSize = () => {
    const sizes = { sm: '12px', md: '14px', lg: '16px' };
    return sizes[this.size()];
  };

  textClass = () => {
    const classes = {
      sm: 'text-[11px] font-bold whitespace-nowrap',
      md: 'text-[12px] font-bold whitespace-nowrap',
      lg: 'text-[13px] font-bold whitespace-nowrap'
    };
    return classes[this.size()];
  };

  style = () => {
    const s = this.statusKey();
    switch (s) {
      case 'created':
      case 'pharmacy registered':
        return { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-200' };

      case 'assigned to employee':
      case 'in progress':
      case 'submit feedback':
        return { bg: 'bg-[#E3F2FD]', text: 'text-[#1976D2]', border: 'border-[#BBDEFB]' };

      case 'pending':
        return { bg: 'bg-[#FEFCE8]', text: 'text-[#CA8A04]', border: 'border-[#FDE047]' };

      case 'approved':
      case 'request approved':
      case 'accepted':
        return { bg: 'bg-[#F0FDF4]', text: 'text-[#16A34A]', border: 'border-[#DCFCE7]' };

      case 'rejected':
      case 'request rejected':
        return { bg: 'bg-[#FEF2F2]', text: 'text-[#DC2626]', border: 'border-[#FEE2E2]' };

      case 'expired':
      case 'request expired':
        return { bg: 'bg-[#F3F4F6]', text: 'text-[#9CA3AF]', border: 'border-[#E5E7EB]' };

      case 'feedback needed':
      case 'request feedback':
        return { bg: 'bg-[#F5F3FF]', text: 'text-[#7C3AED]', border: 'border-[#EDE9FE]' };

      case 'cancelled':
        return { bg: 'bg-[#FFF7ED]', text: 'text-[#F97316]', border: 'border-[#FFEDD5]' };

      default:
        return { bg: 'bg-gray-50', text: 'text-gray-600', border: 'border-gray-200' };
    }
  };

}